export const HANDLED_WHERE_EXPLAINER =
    'In ODO means reviewed here in the admin dashboard; in DM means resolved inside Dental Monitoring.';
